import { AppThunkAction } from 'store';
import { AgreementsService } from '../../../services/agreements.service';
import { AgreementsQuery } from '../../../models/agreements-query';
import { ResponsePagination } from '../../../models/response-pagination';
import { StudyCenterUserAgreements } from '../../../models/study-center-user-agreements';

export const GET_AGREEMENTS = 'user-agreements/GET_AGREEMENTS';
export const SET_LOADING = 'user-agreements/SET_LOADING';
export const SET_ERROR_AGREEMENTS_MESSAGE = 'user-agreements/SET_ERROR_TEST';

export interface GetAgreements {
    type: typeof GET_AGREEMENTS;
    agreements: ResponsePagination<StudyCenterUserAgreements>;
}

export interface SetLoading {
    type: typeof SET_LOADING;
    isLoading?: boolean;
}

export interface SetErrorMessage {
    type: typeof SET_ERROR_AGREEMENTS_MESSAGE;
    agreementsError: string;
}

export type ActionTypes = SetLoading | GetAgreements | SetErrorMessage;

export const actions = {
    getAgreements:
        (params: AgreementsQuery): AppThunkAction<ActionTypes> =>
        async (dispatch) => {
            try {
                dispatch({
                    type: SET_LOADING,
                });

                const agreements = (await AgreementsService.getAgreementsStudyCenter(params)).data;

                dispatch({
                    type: GET_AGREEMENTS,
                    agreements,
                });
            } catch {
                dispatch({
                    type: SET_ERROR_AGREEMENTS_MESSAGE,
                    agreementsError: 'Ошибка',
                });
            }
        },
};
